import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useShop } from '../../../Providers/ShopProvider'
import { useLocation } from 'react-router-dom'


const CategoryNavigationItem = ({ item, categoriesWithSameLevel, Icon, active, hideFeatureListFilter }) => {
    const params = new URLSearchParams(window.location.search)
    const navigate = useNavigate()
    const { setShowFeatureListFilter, productsFilter } = useShop()
    const [isHovered, setIsHovered] = useState(false);
    const location = useLocation()

    const handleNavigate = (category) => {
        let isShopPage = location.pathname.includes('shop')
        // if (active) {
        //     navigate('/shop')
        // }
        // else {
        //     params.set('cat', category.nodeId)
        //     navigate(`/shop?${params.toString()}`)
        // }
        params.set('cat', category.nodeId)
        navigate(`/shop?${params.toString()}`)
        if (hideFeatureListFilter) {
            setShowFeatureListFilter(false)
        }
        else {
            setShowFeatureListFilter(true)
        }
        if (item.catDescription === 'Strona główna') {
            navigate('/')
        }
        else {
            if (productsFilter.SearchingQuery && productsFilter.SearchingQuery !== '' && productsFilter.SearchingQuery !== ' ') {

                const params = new URLSearchParams(window.location.search)
                if (productsFilter) {
                    params.set('q', productsFilter.SearchingQuery)
                } else {
                    params.delete('q')
                }
                navigate(`/shop?${params.toString()}`)
            }
            else if (!isShopPage) {
                navigate(`/shop?${params.toString()}`)
            }
        }
    }
    return (
        item && <div className='col-auto category-navitation-item' onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <div className='row align-items-center' >
                <div className={`col category-navitation-item-tittle `} onClick={() => { handleNavigate(item); }}>
                    {Icon ? <Icon size={32} /> : item.catDescription}
                </div>
            </div>
            {categoriesWithSameLevel && isHovered && <div className='row category-navigation-popup'>
                <div className='col'>
                    {categoriesWithSameLevel && categoriesWithSameLevel.map(category => {
                        return <div className='row category-navitation-subItem' onClick={() => { handleNavigate(category) }
                        }>
                            {category.catDescription}
                        </div>
                    })}
                </div>

            </div>}

        </div >
    )
}

export default CategoryNavigationItem